import React, { useContext, useEffect, useState,useMemo } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import { useToast } from "@chakra-ui/react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";

function FormPage2() {
  const toast = useToast();
  const context = useContext(FormContext);
  const { loginObj, setLoginObj, stateArr, stateList, editable, backward,
    initial,setInitial
   } =
    context;
  const navigate = useNavigate();

  const [yearDrop, setYearDrop] = useState([]);
  const [fp2loader, setFP2loader] = useState(false);

  const [inputdisable, setInputdisable] = useState(false);

  const createarray = (e) => {
    var currentyear = new Date().getFullYear();
    var arrayyer = [];
    for (let i = currentyear; i >= 1970; i--) {
      arrayyer.push(i);
    }
    setYearDrop(arrayyer);
  };

  // const calculateforten = (e) => {
  //   if (loginObj.tenMarksObt && loginObj.tenMaxMarks) {
  //     var cal = (loginObj.tenMarksObt / loginObj.tenMaxMarks) * 100;
  //     console.log(cal);
  //     // setLoginObj(loginObj['tenMarksPercent'] = cal);
  //   }
  // };

  const handlePositive = (e) => {
    let input = e.target.value;

    // Define the regular expression pattern
    const pattern = /^[0-9]*$/;

    // Check if the input matches the pattern
    if (pattern.test(input)) {
      e.target.value = input;
    } else {
      e.target.value = null;
    }
  };

  const handleSaveFormPage2 = () => {
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["db_name"] = "erp_eshiksa";

    if (loginObj.postalCode.length === 6) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
      myHeaders.append("auth_token", localStorage.getItem("token"));
      var raw = JSON.stringify(loginObj);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          var responseObjFS = JSON.parse(result);
          // console.log(responseObjFS);
          if (responseObjFS.success === 1) {
            setFP2loader(false);
            toast({
              title: "Alert",
              description: responseObjFS.msg,
              status: "success",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
            navigate("/FormPage3");
          } else {
            setFP2loader(false);
            toast({
              title: "Alert",
              description: responseObjFS.msg,
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      setFP2loader(false);
      toast({
        title: "Alert",
        description: "Please fill correct Postal code",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    }
  };

  // const handleSubmitPage2 = (e) => {
  //   e.preventDefault();
  //   setFP2loader(true);

  //   if (
  //     loginObj.twlMarksPercent >= 50 &&
  //     loginObj.student_Category !== ("SC/ST" && "BC") &&
  //     loginObj.whetherDisabled === "No"
  //   ) {
  //     handleSaveFormPage2();
  //   } else if (
  //     loginObj.twlMarksPercent >= 40 &&
  //     loginObj.student_Category !== ("General" && "Gen/EWS") &&
  //     loginObj.whetherDisabled === "Yes"
  //   ) {
  //     handleSaveFormPage2();
  //   } else {
  //     setFP2loader(false);
  //     toast({
  //       title: "Alert",
  //       description: "Sorry you fall below the cutoff",
  //       status: "error",
  //       duration: 1000,
  //       isClosable: true,
  //       position: "top",
  //     });
  //   }
  // };

  const handleSubmitPage2 = (e) => {
    e.preventDefault();
    setFP2loader(true);
    if (loginObj.twlExamStatus === "Passed") {
      setFP2loader(false);
      handleSaveFormPage2();
    } else {
      setFP2loader(false);
      toast({
        title: "Alert",
        description: "Sorry you fall below the cutoff",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    }
  };

  useEffect(() => {
    // Prompt confirmation when reload page is triggered
    window.onbeforeunload = () => {
      return "";
    };
    window.scrollTo(0, 0);

    stateList();
    createarray();
    // eslint-disable-next-line
    // Unmount the window.onbeforeunload event
    return () => {
      window.onbeforeunload = null;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let tenthPercent = (loginObj.tenMarksObt / loginObj.tenMaxMarks) * 100;

    setLoginObj({ ...loginObj, tenMarksPercent: tenthPercent });
    // eslint-disable-next-line
  }, [loginObj.tenMarksObt, loginObj.tenMaxMarks]); // eslint-disable-next-line

  useEffect(() => {
    let tewelthPercent = (
      (loginObj.twlObtainedMarks / loginObj.twlMaxMarks) *
      100
    ).toFixed(2);
    console.log(tewelthPercent);
    setLoginObj({ ...loginObj, twlMarksPercent: tewelthPercent });
    // eslint-disable-next-line
  }, [loginObj.twlObtainedMarks, loginObj.twlMaxMarks]); // eslint-disable-next-line

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));
    var raw = JSON.stringify({
      Branch_id: "1763",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);

        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        } else {
          toast({
            title: "Alert",
            description: resultObj.msg,
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  const handlepin = (e) => {
    let input = e.target.value;

    // Define the regular expression pattern
    const pattern = /^[0-9]*$/;

    // Check if the input matches the pattern
    if (pattern.test(input)) {
      e.target.value = input.slice(0, 6);
    } else {
      e.target.value = null;
    }
  };

  // Resetmarks
  const ResetMark = () => {
    const updatedLoginObj = {
      ...loginObj,
      twlMarksPercent: "",
      twlObtainedMarks: "",
      twlMaxMarks: "",
    };
    setLoginObj(updatedLoginObj);
    setInputdisable(false);
    setInitial(false);
  };


  const handleBlur = () => {
    if (loginObj.twlPMarksObt !== "") {
      setInputdisable(true);
    }
  };

// refreshpage

  useMemo(() => {
    const isRefreshed =
      performance &&
      performance.navigation &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD;
    if (isRefreshed) {
      setInitial(true);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i class="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>

          <BackLogout />
        </div>

        <form onSubmit={(e) => handleSubmitPage2(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Address Details</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 1*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 1"
                  name="addLine1"
                  value={loginObj.addLine1}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 2</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 2"
                  name="addLine2"
                  value={loginObj.addLine2}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">City*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="City"
                  name="city"
                  value={loginObj.city}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Country*</label>
                <select
                  className="form-select"
                  name="country"
                  value={loginObj.country}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="India">India</option>
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">State/Province*</label>
                <select
                  name="stateNameAdd"
                  value={loginObj.stateNameAdd}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {stateArr.map((item, i) => {
                    return (
                      <option key={i} value={item.state_name}>
                        {item.state_name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Postal code*</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Postal Code"
                  name="postalCode"
                  value={loginObj.postalCode}
                  onKeyUp={handlepin}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 10th</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Name of the School- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 10th"
                  name="tenSchoolName"
                  value={loginObj.tenSchoolName}
                  onChange={(e) => {
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    });
                    createarray(e);
                  }}
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Board- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 10th"
                  name="tenSchoolBoard"
                  value={loginObj.tenSchoolBoard}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Year of Passing - 10th*</label>
                <select
                  name="tenPassYear"
                  value={loginObj.tenPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Percentage - 10th *</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Percentage - 10th"
                  name="tenMarksPercent"
                  value={loginObj.tenMarksPercent}
                  onKeyUp={(e) => handlePositive(e)}
                  onChange={(e) => {
                    if (e.target.value < 101) {
                      let input = e.target.value;
                      e.target.value = input.slice(0, 5);
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      });
                    } else {
                      e.target.value = 0;
                    }
                  }}
                  required
                />
              </div>
            </div>
            {/* <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Maximum Marks *</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Maximum Marks"
                  name="tenMaxMarks"
                  value={loginObj.tenMaxMarks}
                  onKeyUp={(e) => calculateforten(e)}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Marks Obtained *</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Marks Obtained"
                  name="tenMarksObt"
                  value={loginObj.tenMarksObt}
                  onKeyUp={(e) => calculateforten(e)}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div> */}
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 12th</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-6">
                <label className="form-label">Name of the School- 12th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 12th"
                  name="twlSchoolName"
                  value={loginObj.twlSchoolName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-6">
                <label className="form-label">Board- 12th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 12th"
                  name="twlBoardName"
                  value={loginObj.twlBoardName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Year of Passing - 12th*</label>
                <select
                  name="twlPassYear"
                  value={loginObj.twlPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Exam Status-12th*</label>
                <select
                  name="twlExamStatus"
                  value={loginObj.twlExamStatus}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="Passed">Passed</option>
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Stream*</label>
                {loginObj.twlStream !== "Other" ? (
                  <input
                    name="twlStream"
                    value={loginObj.twlStream}
                    required
                    className="form-control"
                    readOnly
                  />
                ) : (
                  <input
                    name="twlStream"
                    value={loginObj.OtherStreamName}
                    required
                    className="form-control"
                    readOnly
                  />
                )}
              </div>
            </div>

            <div className="row justify-content-end p-4">
              <button
                type="reset"
                className="btn btn-primary col-md-3"
                onClick={ResetMark}
              >
                {" "}
                Set Marks
              </button>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">
                  Maximum/Total Marks (As per 10+2 DMC)*
                </label>
                <input
                  type="number"
                  name="twlMaxMarks"
                  value={loginObj.twlMaxMarks}
                  required
                  className="form-control"
                  placeholder="Maximum Marks"
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  disabled={
                    loginObj.twlObtainedMarks !== "" || (!editable && !backward)
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">
                  Marks Obtained (As per 10+2 DMC)*
                </label>
                <input
                  type="number"
                  name="twlObtainedMarks"
                  value={loginObj.twlObtainedMarks}
                  required
                  className="form-control"
                  placeholder="Obtained Marks"
                  // onChange={(e) => {
                  //   if (e.target.value <= parseInt(loginObj.twlMaxMarks)) {
                  //     setLoginObj({
                  //       ...loginObj,
                  //       [e.target.name]: e.target.value,
                  //     });
                  //   }
                  // }}
                  onChange={(e) => {
                    if (e.target.value <= parseInt(loginObj.twlMaxMarks)) {
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      });
                    } else {
                      toast({
                        title: "Alert",
                        description: "Check marks obtained or note below",
                        status: "error",
                        duration: 1000,
                        isClosable: true,
                        position: "top",
                      });
                    }
                  }}
                  onBlur={handleBlur}
                  // disabled={inputdisable || (!editable && backward)}
                  disabled={
                    inputdisable ||
                              (!editable && !backward) ||
                              initial
                            }
                />
              </div>

              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Percentage - 12th *</label>

                <input
                  type="number"
                  name="twlMarksPercent"
                  value={loginObj.twlMarksPercent}
                  required
                  className="form-control"
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="row justify-content-around my-5">
            <div style={{ color: "#ed0909" }}>
              <label>Note:</label>
              <h6>
                Please click on "Set Marks" button for entering marks or edit
                marks submitted. In case marks not submitted may first select
                the value of marks to be changed and then punch the desired
                numeric value.
              </h6>
            </div>
            {/* <button
              type="submit"
              className="btn btn-primary w-25"
              disabled={fp2loader}
            >
              Submit
              {fp2loader && <Loader />}
            </button> */}
            <button
              type="submit"
              className="btn btn-primary w-25"
              disabled={
                fp2loader || !loginObj.twlMaxMarks || !loginObj.twlObtainedMarks
              }
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default FormPage2;
